export type ReasonTypes =
  | 'Counterfeit item'
  | 'Advertising soliciting'
  | 'Inappropriate content'
  | 'Prohibited item'
  | 'Digital item'
  | 'Trade offline transaction'
  | 'Stolen good'
  | 'Keyword stuffing'
  | 'Wrong brand category'
  | 'No intent to sell'
  | 'Hate offensive'
  | 'Other'
  | '';
export const REASONS: { id: string; label: string; value: ReasonTypes }[] = [
  // {
  //   id: '1',
  //   label: 'Select an issue',
  //   value: '',
  // },
  {
    id: '2',
    label: 'Counterfeit item',
    value: 'Counterfeit item',
  },
  {
    id: '3',
    label: 'Advertising/soliciting',
    value: 'Advertising soliciting',
  },
  {
    id: '4',
    label: 'Inappropriate content',
    value: 'Inappropriate content',
  },
  {
    id: '5',
    label: 'Prohibited item',
    value: 'Prohibited item',
  },
  {
    id: '6',
    label: 'Digital item',
    value: 'Digital item',
  },
  {
    id: '7',
    label: 'Trade/offline transaction',
    value: 'Trade offline transaction',
  },
  {
    id: '8',
    label: 'Stolen good',
    value: 'Stolen good',
  },
  {
    id: '9',
    label: 'Keyword stuffing',
    value: 'Keyword stuffing',
  },
  {
    id: '10',
    label: 'Wrong brand/category',
    value: 'Wrong brand category',
  },
  {
    id: '11',
    label: 'No intent to sell',
    value: 'No intent to sell',
  },
  {
    id: '12',
    label: 'Hate/offensive',
    value: 'Hate offensive',
  },
  {
    id: '13',
    label: 'Other',
    value: 'Other',
  },
];
